// extracted by mini-css-extract-plugin
export var fullHeightState = "_1p-7";
export var headerCell = "_1p-1";
export var loadingStateCell = "_1p-4";
export var rowWrapper = "_1p-3";
export var standaloneTable = "_1p-8";
export var standaloneTableWithBodyFill = "_1p-9";
export var stateCell = "_1p-5";
export var table = "_1p-0";
export var tableBodyFiller = "_1p-6";
export var white = "_1p-2";